var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VContent',[_c('h1',[_vm._v("\n        "+_vm._s(_vm.$store.state.user)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }